import { Component, OnInit, Input } from '@angular/core';

import { OnlineOrder, Customer, Company } from '../../../../shared/models';

import { faWhatsapp, faPhone } from '../../../../icons';

@Component({
    selector: 'app-contact-buttons',
    templateUrl: './contact-buttons.component.html',
    styleUrls: ['./contact-buttons.component.scss'],
    standalone: false
})
export class ContactButtonsComponent implements OnInit {
	@Input() customer: Customer;
	@Input() company: Company;
	@Input() whatsMsg: string;

  faWhatsapp = faWhatsapp;
  faPhone = faPhone;

  constructor() { }

  ngOnInit(): void {
  }

  makeCall(event) {
    event.stopPropagation();
    window.open("tel:" + this.company.phone, "_blank");
  }

  sendWhatsappMsg(event) {
    event.stopPropagation();
    let encodedMsg = encodeURIComponent(this.whatsMsg);

    window.open(`https://wa.me/55${this.company.whatsapp_number}?text=${encodedMsg}`, "_blank");
  }
}
